import { createFeatureSelector } from '@ngrx/store';
import { InsuredState } from './insured.state';

export const selectInsured = createFeatureSelector<InsuredState>('insured');
